import { render, staticRenderFns } from "./customer.vue?vue&type=template&id=6a80793c&scoped=true&lang=pug&"
import script from "./customer.vue?vue&type=script&lang=ts&"
export * from "./customer.vue?vue&type=script&lang=ts&"
import style0 from "./customer.vue?vue&type=style&index=0&id=6a80793c&lang=sass&scoped=true&"
import style1 from "./customer.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a80793c",
  null
  
)

export default component.exports